import { Action, Col, Row, Tile } from '@op/opds.opux';
import { type ReactElement } from 'react';
import styles from './ErrorPage.module.scss';
import PageHeading from '../PageHeading/PageHeading';
import i18n from 'i18n';
import { getInitialState } from 'utils';

interface ErrorPageProps {
  componentId: string;
  headerText: string;
  errorMessageText: string;
  image: ReactElement | string;
}

/**
 * Displays an error message page with provided headerText, errorMessageText and image.
 * containsLinks is a boolean prop used to define whether links should be visible on the page
 */
export const ErrorPage = ({
  componentId,
  headerText,
  errorMessageText,
  image,
}: ErrorPageProps) => {
  const { authenticatedCustomer } = getInitialState();

  const INSURANCES_HOME_PAGE_LINK_URL = i18n.t(
    authenticatedCustomer
      ? 'link.insurancesHomePage.INSURANCES_HOME_PAGE_LINK_URL_AUTHENTICATED'
      : 'link.insurancesHomePage.INSURANCES_HOME_PAGE_LINK_URL_UNAUTHENTICATED'
  );
  const CUSTOMER_HOME_PAGE_LINK_URL = authenticatedCustomer
    ? i18n.t('link.homePage.CUSTOMER_HOME_PAGE_LINK_URL_AUTHENTICATED')
    : '/';

  return (
    <Row center data-testid={componentId}>
      <div
        id={componentId}
        className='opds App opds-styles-v1-elements-headings-small opds-styles-v1-text-body-large center'>
        <Row>
          <Col sm={6}>
            <h1>{i18n.t('common.opLifeInsurance')}</h1>
          </Col>
        </Row>
        <Tile>
          <Row middle className={styles.content}>
            <Col sm={6}>
              <PageHeading title={headerText} />
              <p style={{ marginBottom: '2rem' }}>{errorMessageText}</p>
              <div className={styles.links}>
                <Action
                  href={INSURANCES_HOME_PAGE_LINK_URL}
                  style={{ display: 'block' }}>
                  {i18n.t('link.insurancesHomePage.text')}
                </Action>
                <Action href={CUSTOMER_HOME_PAGE_LINK_URL}>
                  {i18n.t('link.homePage.text')}
                </Action>
              </div>
            </Col>
            <Col sm={6}>
              {typeof image === 'string' ? (
                <img
                  style={{ width: '100%' }}
                  role='presentation'
                  src={image}
                  alt=''
                />
              ) : (
                <div style={{ width: '100%' }} role='presentation'>
                  {image}
                </div>
              )}
            </Col>
          </Row>
        </Tile>
      </div>
    </Row>
  );
};
